/* eslint-disable global-require */
import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

export default new VueRouter({
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    // When shifting between same type of pages, don't auto scroll to top.
    if (to.name && from.name && to.name === from.name) {
      return savedPosition;
    }

    return { x: 0, y: 0 };
  },
  routes: [
    {
      name: 'account-billing',
      path: '/account/billing',
      component: require('./pages/account/billing/index.vue').default,
    },
    {
      name: 'account-details',
      path: '/account',
      component: require('./pages/account/details/index.vue').default,
      alias: [
        '/account/details',
      ],
    },
    {
      name: 'account-team-billing',
      path: '/account/team/billing',
      component: require('./pages/account/team/billing/index.vue').default,
    },
    {
      name: 'account.team.details',
      path: '/account/team/details',
      component: require('./pages/account/team/details/index.vue').default,
    },
  ],
});
